import {Button} from 'antd'

export function ButtonLinkLike (props) {
  const {children, className, ..._props} = props

  let classNames = ['btn-link-like', className].join(' ')

  return <Button type="link" color="default" className={classNames} {..._props}>{children}</Button>
}